import { ProjectId } from '../context/ProjectContext';

export interface CollectionDef {
  name: string;
  path: string;
  description: string;
}

export const ADMIRAL_COLLECTIONS: CollectionDef[] = [
  { name: 'Services', path: '/services', description: 'Manage company services offered to clients' },
  { name: 'References', path: '/references', description: 'Showcase portfolio items and past projects' },
  { name: 'Locations', path: '/locations', description: 'Manage office locations and their categories' },
  { name: 'Showreel', path: '/showreel', description: 'Video showcase items for the homepage' },
  { name: 'Clients', path: '/clients', description: 'Manage client logos and information' },
  { name: 'HQ', path: '/hq-items', description: 'Update headquarter information items' },
  { name: 'Supporters', path: '/supporters', description: 'Manage supporters and partners' },
];

export const BOLT_JR_COLLECTIONS: CollectionDef[] = [
  { name: 'Hero', path: '/bolt-jr/hero', description: 'Hero section content and images' },
  { name: 'Paragraphs', path: '/bolt-jr/paragraphs', description: 'Standalone text blocks placed between sections (separators, callouts)' },
  { name: 'Showcase', path: '/bolt-jr/showcase', description: 'FOOD / BEAUTY / SKINCARE looped video banners' },
  { name: 'Capabilities', path: '/bolt-jr/capabilities', description: 'Technical Capabilities / In-house Production rows (text + bullet box, no section heading)' },
  { name: 'Key Features', path: '/bolt-jr/keyfeatures', description: 'Key differentiator feature cards' },
  { name: 'Features', path: '/bolt-jr/features', description: 'Feature highlights with descriptions' },
  { name: 'Track Options', path: '/bolt-jr/trackoptions', description: 'Precision rail track options' },
  { name: 'Specifications', path: '/bolt-jr/specifications', description: 'Technical specifications table' },
  { name: 'Controllers', path: '/bolt-jr/controllers', description: 'Controller hardware items' },
  { name: 'Accessories', path: '/bolt-jr/accessories', description: 'Accessory hardware items' },
  { name: 'Videos', path: '/bolt-jr/videos', description: 'Video showcase items' },
];

export const PROJECT_LABELS: Record<ProjectId, string> = {
  admiral: 'Admiral',
  'bolt-jr': 'Bolt Jr+',
};

export function getCollectionsForProject(project: ProjectId): CollectionDef[] {
  switch (project) {
    case 'admiral':
      return ADMIRAL_COLLECTIONS;
    case 'bolt-jr':
      return BOLT_JR_COLLECTIONS;
    default:
      return ADMIRAL_COLLECTIONS;
  }
}

/**
 * Derive the section id used by the page-config `sectionOrder` from a
 * collection definition. Mirrors the logic in `PageConfigPage`'s
 * `buildSectionLabels`: take the last path segment, mapping the UI-only
 * `hq-items` route to the backend collection id `hq`.
 */
export function collectionSectionId(c: CollectionDef): string {
  const segments = c.path.split('/').filter(Boolean);
  const last = segments[segments.length - 1] ?? '';
  return last === 'hq-items' ? 'hq' : last;
}
